// FormXIXWageSlip.js
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 11,
    fontFamily: 'Times-Roman',
  },
  font:{
    fontWeight: 300
  },
  centerText: {
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 4,
  },
  subText: {
    textAlign: 'center',
    fontSize: 10,
    marginBottom: 10,
  },
  bold: {
    fontWeight: 'bold',
  },
  section: {
    marginBottom: 4,
  },
  indent: {
    marginLeft: 12,
  }
});

const FormXIXWageSlip = ({mainData, userDetails, month, companyDetails}) => {

  console.log("mainData -------> ", mainData)

  return <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.centerText}>FORM XIX</Text>
      <Text style={styles.subText}>[See rule 78 (1) (b)]</Text>
      <Text style={{ ...styles.centerText, marginBottom: 12 }}>Wage Slip</Text>

      <View style={styles.section}>
        <Text style={styles.bold}>Name and address of contractor : <Text> 
          <Text style={styles.font}>{companyDetails.contractorName ? companyDetails.contractorName : "-" }, </Text>
          <Text style={styles.font}>{companyDetails.contractorAddress ? companyDetails.contractorAddress : "-" } </Text>
        </Text></Text>
        <Text style={styles.bold}>Name and father's/husband's name of the workman : <Text style={styles.font}> {userDetails[0]?.full_name } / {userDetails[0]?.personalDetails?.fatherName }</Text></Text>
        <Text style={styles.bold}>Nature and location of work :
          <Text style={styles.font}>{ companyDetails.natureOfWork ? companyDetails.natureOfWork : "-" } / </Text>
          <Text style={styles.font}>{ companyDetails.locationOfWork ? companyDetails.locationOfWork : "-" } </Text>
        </Text>
        <Text style={styles.bold}>For the week/fortnight/month ending : -</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.bold}>1. Number of days worked : -</Text>
        <Text style={styles.bold}>2. Number of units worked in case of piece rate workers : -</Text>
        <Text style={styles.bold}>3. Rate of daily wages/piece rate : -</Text>
        <Text style={styles.bold}>4. Amount of overtime wages : -</Text>
        <Text style={styles.bold}>5. Gross wages payable : <Text style={styles.font}> {mainData?.salaryOutput?.grossSalary}</Text></Text>
        <Text style={styles.bold}>7. Net amount of wages paid : <Text style={styles.font}> {mainData?.salaryOutput?.netSalary}</Text></Text>
        <Text style={styles.bold}>Initials of the Contractor or his representative : -</Text>
      </View>
    </Page>
  </Document>
}

export default FormXIXWageSlip;
